import { useLayoutEffect } from 'react';

var index =  useLayoutEffect ;

export default index;



//////////////////
// WEBPACK FOOTER
// ./node_modules/use-isomorphic-layout-effect/dist/use-isomorphic-layout-effect.browser.esm.js
// module id = 434
// module chunks = 4